(function(){
  if (window.__newaCart) return;
  window.__newaCart = true;
  const CFG = window.NEWA_CART_CFG || {};
  const MAR = CFG.mar, UVA = CFG.uva;
  const PRODUCT = CFG.productUrl || '/';
  const CHECKOUT = CFG.checkoutUrl || '/checkout';
  const root = document.querySelector('[data-nwc-root]');
  const drawerRoot = document.querySelector('[data-nwc-drawer-root]');
  if (!root && !drawerRoot) return;
  const MQ = window.matchMedia('(max-width:780px)');
  const MAXN = 8;
  const THUMB = 'https://cdn.shopify.com/s/files/1/0833/7283/5045/files/newa-carrinho-kit-v2.webp';
  const FLAVORS = [
    { k: 'mar', name: 'Maracujá', grad: 'linear-gradient(160deg,#f0c65e,#d9a42c)' },
    { k: 'uva', name: 'Uva', grad: 'linear-gradient(160deg,#8a6cb8,#5d4390)' }
  ];

  const st = document.createElement('style');
  st.textContent = ''
    + '.nwc-fls{display:flex;flex-direction:column;gap:8px;margin-top:12px;max-width:380px}'
    + '.nwc-fls.full{grid-column:1 / -1;margin-top:0;max-width:none}'
    + '.nwc-left{flex-basis:600px}'
    + '.nwc-fl{display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;column-gap:12px;padding:8px 10px 8px 8px;border-radius:14px;background:#fff;border:1.5px solid #e2eeef;transition:border-color .15s}'
    + '.nwc-fl.on{border-color:#0c4f5a}'
    + '.nwc-fl-sw{display:block;width:32px;height:32px;border-radius:9px;flex:none}'
    + '.nwc-fl-name{font-size:15px;font-weight:700;color:#0c3f4a;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'
    + '.nwc-fl-step{display:flex;align-items:center;gap:12px}'
    + '.nwc-fl-q{min-width:22px;text-align:center;font-size:17px;font-weight:800;color:#0c3f4a;font-variant-numeric:tabular-nums;-webkit-user-select:none;user-select:none}'
    + '.nwc .nwc-fbtn{width:32px;height:32px;min-width:0;min-height:0;border-radius:50%;box-sizing:border-box;flex:none;padding:0;margin:0;background:#fff;font-family:inherit;line-height:1;letter-spacing:0;border:2px solid #0c4f5a;color:#0c4f5a;font-size:17px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:none;-webkit-appearance:none;appearance:none;-webkit-user-select:none;user-select:none;touch-action:manipulation;-webkit-tap-highlight-color:transparent;transition:border-color .15s,color .15s}'
    + '.nwc .nwc-fbtn:disabled{border-color:#dce9ea;color:#b7cdd0;cursor:default;opacity:1}'
    + '.nwc .nwc-fbtn::before,.nwc .nwc-fbtn::after{display:none}'
    + '.nwc-rm-under{align-self:flex-start;margin-top:8px}'
    + '.nwc-item.sm{row-gap:12px}'
    + '.nwc-item.sm .nwc-fl{column-gap:10px;padding:7px 8px 7px 7px;border-radius:12px}'
    + '.nwc-item.sm .nwc-fl-sw{width:28px;height:28px;border-radius:8px}'
    + '.nwc-item.sm .nwc-fl-name{font-size:13.5px}'
    + '.nwc-item.sm .nwc-fl-step{gap:10px}'
    + '.nwc-item.sm .nwc-fl-q{min-width:20px;font-size:15px}'
    + '.nwc .nwc-item.sm .nwc-fbtn{width:28px;height:28px;font-size:15px}'
    + '.nwc-dw-midrow2{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:2px}'
    + '.nwc-dw-midrow2 .nwc-remove{font-size:11px;letter-spacing:1px}'
    + '.nwc-mob-item{row-gap:14px}'
    + '.nwc-mob-item .nwc-fl{padding:7px 8px;border-radius:14px}'
    + '.nwc-mob-item .nwc-fl-sw{width:34px;height:34px;border-radius:10px}'
    + '.nwc-mob-item .nwc-fl-name{font-size:14.5px}'
    + '.nwc .nwc-mob-item .nwc-fbtn{width:38px;height:38px;font-size:19px}'
    + '.nwc-mob-item .nwc-rm-under{margin-top:6px;font-size:11px;letter-spacing:1px}'
    + '@media(max-width:780px){'
    + '.nwc-dw-body{padding:16px 18px;gap:12px}'
    + '.nwc-item.sm{padding:14px 16px;column-gap:12px}'
    + '.nwc-item.sm .nwc-thumb{width:60px;height:60px;border-radius:11px}'
    + '.nwc-item.sm .nwc-it-title{font-size:13.5px}'
    + '.nwc-item.sm .nwc-ittot.sm{font-size:14px}'
    + '.nwc-item.sm .nwc-fl{padding:6px 7px}'
    + '.nwc-item.sm .nwc-fl-sw{width:30px;height:30px;border-radius:9px}'
    + '.nwc .nwc-item.sm .nwc-fbtn{width:32px;height:32px;font-size:17px}'
    + '.nwc-dw-midrow2 .nwc-remove{font-size:10.5px}'
    + '.nwc-item.sm .nwc-dw-midrow2 .nwc-orig{font-size:11.5px}'
    + '}';
  document.body.appendChild(st);

  const ini = CFG.initial || {};
  const state = { mar: ini.mar || 0, uva: ini.uva || 0, orig: ini.origCents || 0, tot: ini.totCents || 0,
    applied: false, couponErr: false, coupon: '', drawer: false, syncing: false };
  let unit = (state.mar + state.uva) > 0 ? Math.round(state.orig / (state.mar + state.uva)) : 0;
  let localVer = 0, sentVer = 0, inFlight = false, timer = null;

  const N = () => state.mar + state.uva;
  const isEmpty = () => N() <= 0;
  const fmt = c => 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;');
  const tierPct = n => n >= 4 ? 15 : n === 3 ? 10 : n === 2 ? 5 : 0;
  const hide = on => on ? '' : 'display:none';
  const caixas = () => N() + (N() === 1 ? ' caixa' : ' caixas');
  const kitTitle = () => 'Newa - Repositor de Eletrólitos · kit ' + caixas();
  const parcel = v => 'ou 3x de ' + fmt(Math.floor(v.total / 3)) + ' sem juros';
  const mbl = v => v.freteOk ? 'Total com frete grátis' : 'Total sem frete';
  const freteTxt = v => v.freteOk ? 'GRÁTIS' : 'a partir de R$ 9,90';
  const canMinus = k => state[k] > 0 && N() > 1 && !state.syncing;
  const canPlus = () => N() < MAXN && !state.syncing;

  function calc(){
    const n = N(), orig = state.orig, tot = state.tot;
    const p = tierPct(n);
    const cup = state.applied ? Math.round(tot * 0.10) : 0;
    return { n, orig, tot, descKit: Math.max(0, orig - tot), offPct: p ? p + '% OFF' : '',
      freteOk: n >= 2, maxOk: n >= 4, cup, total: tot - cup,
      stick: n > 0 ? Math.round(tot / (n * 14)) : 0, pct: Math.min(n, 4) / 4 * 100 };
  }
  function missionMsg(){
    const n = N();
    if (n <= 1) return 'Adicione +1 caixa e ganhe FRETE GRÁTIS';
    if (n === 2) return 'Frete grátis garantido! Faltam 2 caixas para o desconto máximo';
    if (n === 3) return 'Frete grátis garantido! Falta 1 caixa para o desconto máximo';
    return 'Missão cumprida: frete grátis + desconto máximo de 15%';
  }

  function svg(name, sw){
    sw = sw || 2;
    if (name === 'tag') return `<svg viewBox='0 0 24 24' fill='none' stroke='#0c4f5a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M20 12l-8 8-8.5-8.5V4H11l9 8z'/><circle cx='7.5' cy='7.5' r='1.3'/></svg>`;
    const P = {
      truck: `<path d='M3 7h10v9H3z'/><path d='M13 10h4l3 3v3h-7'/><circle cx='7' cy='18' r='1.6'/><circle cx='16.5' cy='18' r='1.6'/>`,
      pct: `<path d='M19 5L5 19'/><circle cx='7' cy='7' r='2.4'/><circle cx='17' cy='17' r='2.4'/>`,
      check: `<path d='M5 12.5l4.5 4.5L19 7.5'/>`,
      lock: `<rect x='5' y='11' width='14' height='9' rx='2'/><path d='M8 11V7a4 4 0 0 1 8 0v4'/>`,
      bag: `<path d='M6 8h12l-1.1 12H7.1L6 8z'/><path d='M9 8V6a3 3 0 0 1 6 0v2'/>`,
      x: `<path d='M6 6l12 12M18 6L6 18'/>`
    };
    if (!P[name]) return '';
    return `<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='${sw}' stroke-linecap='round' stroke-linejoin='round'>${P[name]}</svg>`;
  }

  function missionHTML(v, sm){
    return `<div class='nwc-mission${sm ? ' sm' : ''}'>`
      + `<div class='nwc-mission-msg' data-f='mmsg'>${esc(missionMsg())}</div>`
      + `<div class='nwc-track'><div class='nwc-fill' data-f='fill' style='width:${v.pct}%'><span></span></div>`
      + `<div class='nwc-node frete ${v.freteOk ? 'on' : 'off'}' data-f='nfrete' title='Frete grátis com 2 caixas'>${svg('truck')}</div>`
      + `<div class='nwc-node max ${v.maxOk ? 'on' : 'off'}' data-f='nmax' title='Desconto máximo com 4 caixas'>${svg('pct')}</div></div>`
      + `<div class='nwc-lblrow'><span class='nwc-lbl frete ${v.freteOk ? 'on' : 'off'}' data-f='lfrete'>Frete grátis</span>`
      + `<span class='nwc-lbl max ${v.maxOk ? 'on' : 'off'}' data-f='lmax'>−15% máx.</span></div></div>`;
  }
  function flavorRow(f){
    const c = state[f.k], lower = f.name.toLowerCase();
    return `<div class='nwc-fl${c > 0 ? ' on' : ''}' data-f='row${f.k}'>`
      + `<span class='nwc-fl-sw' style='background:${f.grad}'></span>`
      + `<span class='nwc-fl-name'>${f.name}</span>`
      + `<span class='nwc-fl-step'>`
      + `<button type='button' class='nwc-fbtn' data-a='minus' data-k='${f.k}' data-f='m${f.k}' aria-label='Tirar 1 caixa de ${lower}'${canMinus(f.k) ? '' : ' disabled'}>−</button>`
      + `<span class='nwc-fl-q' data-f='q${f.k}'>${c}</span>`
      + `<button type='button' class='nwc-fbtn' data-a='plus' data-k='${f.k}' data-f='p${f.k}' aria-label='Adicionar 1 caixa de ${lower}'${canPlus() ? '' : ' disabled'}>+</button>`
      + `</span></div>`;
  }
  const flavorsHTML = full => `<div class='nwc-fls${full ? ' full' : ''}'>${FLAVORS.map(flavorRow).join('')}</div>`;
  const removeEl = extra => `<div class='nwc-remove${extra ? ' ' + extra : ''}' role='button' data-a='remove'>REMOVER</div>`;

  function upgradeHTML(sm){
    const u = unit || 5900, p4 = Math.round(4 * u * 0.85), s4 = 4 * u - p4;
    if (sm) return `<div class='nwc-up sm'><div class='nwc-up-row'><div class='nwc-up-img'><img src='${CFG.boxImg}' alt='Caixa newa'></div>`
      + `<div class='nwc-up-txt'><div class='nwc-up-title'>Cumpra a missão: leve 4 caixas</div>`
      + `<div class='nwc-up-desc'>Frete grátis + 15% OFF · ${fmt(p4)} <b>· economize ${fmt(s4)}</b></div></div></div>`
      + `<button type='button' class='nwc-up-btn' data-a='upgrade'>Fazer upgrade para 4 caixas</button></div>`;
    return `<div class='nwc-up'><div class='nwc-up-img'><img src='${CFG.boxImg}' alt='Caixa newa'></div>`
      + `<div class='nwc-up-txt'><div class='nwc-up-title'>Cumpra a missão: leve 4 caixas</div>`
      + `<div class='nwc-up-desc'>Frete grátis + 15% OFF — o maior desconto do site.</div>`
      + `<div class='nwc-up-price'>4 caixas por ${fmt(p4)} <span>· economize ${fmt(s4)}</span></div></div>`
      + `<button type='button' class='nwc-up-btn' data-a='upgrade'>Fazer upgrade</button></div>`;
  }
  function bestHTML(sm){
    const txt = sm ? 'Maior desconto do site (15%) + frete grátis garantidos.' : 'Missão cumprida! Você garantiu o maior desconto do site (15%) e o frete grátis.';
    return `<div class='nwc-best${sm ? ' sm' : ''}'><div class='nwc-best-ic'>${svg('check', 2.6)}</div><div class='nwc-best-txt'>${txt}</div></div>`;
  }
  const upsellHTML = (v, sm) => `<div data-f='up' style='${hide(v.n < 4)}'>${upgradeHTML(sm)}</div><div data-f='best' style='${hide(v.n >= 4)}'>${bestHTML(sm)}</div>`;

  function couponHTML(sm){
    if (state.applied) return `<div class='nwc-cupchip${sm ? ' sm' : ''}'>${svg('tag')}<div class='nwc-cupchip-code'>NEWA10 <span>(−10%)</span></div><div class='nwc-remove' role='button' data-a='rmcoupon'>REMOVER</div></div>`;
    const err = state.couponErr ? `<div class='nwc-cuperr${sm ? ' sm' : ''}'>Cupom inválido — experimente NEWA10</div>` : '';
    return `<div class='nwc-cuprow${sm ? ' sm' : ''}'><input class='nwc-cupinput' type='text' value='${esc(state.coupon)}' placeholder='${sm ? 'Cupom' : 'Cupom de desconto'}' aria-label='Cupom de desconto' data-a='coupon'>`
      + `<button type='button' class='nwc-cupbtn' data-a='apply'>Aplicar</button></div>` + err;
  }
  const cupBox = sm => `<div data-f='cupbox' data-sm='${sm ? 1 : 0}'>${couponHTML(sm)}</div>`;

  function calcHTML(v, sm){
    return `<div class='nwc-calc${sm ? ' sm' : ''}'>`
      + `<div class='nwc-line'><span class='k'>Preço original${sm ? '' : ` (<span data-f='caixas'>${caixas()}</span>)`}</span><span class='v' data-f='lorig'>${fmt(v.orig)}</span></div>`
      + `<div class='nwc-line' data-f='lkit' style='${hide(v.descKit > 0)}'><span class='k'>Desconto do kit (<span data-f='lkitlbl'>${v.offPct}</span>)</span><span class='v cyan' data-f='lkitval'>−${fmt(v.descKit)}</span></div>`
      + `<div class='nwc-line' data-f='lcup' style='${hide(state.applied)}'><span class='k'>Cupom NEWA10 (−10%)</span><span class='v cyan' data-f='lcupval'>−${fmt(v.cup)}</span></div>`
      + `<div class='nwc-line'><span class='k'>Frete</span><span class='v${v.freteOk ? ' free' : ''}' data-f='lfreteval'>${freteTxt(v)}</span></div></div>`;
  }

  function desktopHTML(v){
    const left = `<div class='nwc-left'>`
      + `<div class='nwc-head'><h1 class='nwc-h1'>Seu carrinho</h1><div class='nwc-sub' data-f='sub'>${caixas()} · 1 produto</div></div>`
      + `<div class='nwc-card'>${missionHTML(v, false)}</div>`
      + `<div class='nwc-item nwc-card'><div class='nwc-thumb'><img src='${THUMB}' alt='Caixas newa'></div>`
      + `<div class='nwc-it-mid'><div class='nwc-it-title' data-f='title'>${kitTitle()}</div>`
      + flavorsHTML(false) + removeEl('nwc-rm-under') + `</div>`
      + `<div class='nwc-it-right'><div class='nwc-orig' data-f='orig' style='${hide(v.descKit > 0)}'>${fmt(v.orig)}</div>`
      + `<div class='nwc-ittot' data-f='ittot'>${fmt(v.tot)}</div>`
      + `<div class='nwc-perstick' data-f='perstick'>${fmt(v.stick)} por stick</div>`
      + `<div class='nwc-offbadge' data-f='offbadge' style='${hide(v.descKit > 0)}'>${v.offPct}</div></div></div>`
      + upsellHTML(v, false)
      + `</div>`;
    const right = `<div class='nwc-right'><div class='nwc-sum-title'>Resumo do pedido</div>`
      + cupBox(false) + calcHTML(v, false)
      + `<div class='nwc-totalrow'><span class='nwc-total-k'>Total</span><span class='nwc-total-v' data-f='total'>${fmt(v.total)}</span></div>`
      + `<div class='nwc-parcel' data-f='parcel'>${parcel(v)}</div>`
      + `<button type='button' class='nwc-checkout' data-a='checkout'>${svg('lock', 2.2)}Finalizar compra</button>`
      + `<div class='nwc-pay'>Pix, cartão em até 3x ou boleto</div>`
      + `<div class='nwc-continue-wrap'><a class='nwc-continue' href='${PRODUCT}'>← ou continue comprando</a></div></div>`;
    return `<div class='nwc-grid'>${left}${right}</div>`;
  }
  function mobileHTML(v){
    const item = `<div class='nwc-mob-item'><div class='nwc-thumb mob'><img src='${THUMB}' alt='Caixas newa'></div><div class='nwc-mob-mid'>`
      + `<div class='nwc-mob-toprow'><div class='nwc-it-title mob' data-f='title'>${kitTitle()}</div>`
      + `<div class='nwc-mob-price'><div class='nwc-orig' data-f='orig' style='${hide(v.descKit > 0)}'>${fmt(v.orig)}</div><div class='nwc-mob-total' data-f='ittot'>${fmt(v.tot)}</div></div></div>`
      + `<div class='nwc-perstick mob' data-f='perstick'>${fmt(v.stick)} por stick</div>`
      + removeEl('nwc-rm-under') + `</div>`
      + flavorsHTML(true) + `</div>`;
    const sum = `<div class='nwc-mob-sum'><div class='nwc-sum-title'>Resumo do pedido</div>`
      + cupBox(true) + calcHTML(v, false)
      + `<div class='nwc-totalrow mob'><span class='nwc-total-k'>Total</span><span class='nwc-total-v mob' data-f='total'>${fmt(v.total)}</span></div>`
      + `<div class='nwc-parcel' data-f='parcel'>${parcel(v)}</div>`
      + `<div class='nwc-pay'>Pix, cartão em até 3x ou boleto</div></div>`;
    const content = `<div class='nwc-mob'>`
      + `<div class='nwc-head'><h1 class='nwc-h1'>Seu carrinho</h1><div class='nwc-sub' data-f='sub'>${caixas()} · 1 produto</div></div>`
      + `<div class='nwc-card'>${missionHTML(v, true)}</div>`
      + item + upsellHTML(v, true) + sum
      + `<div class='nwc-continue-wrap'><a class='nwc-continue' href='${PRODUCT}'>← ou continue comprando</a></div>`
      + `</div>`;
    const bar = `<div class='nwc-mobbar'><div class='nwc-mobbar-l'><div class='nwc-mobbar-lbl' data-f='mbl'>${mbl(v)}</div><div class='nwc-mobbar-tot' data-f='total'>${fmt(v.total)}</div></div>`
      + `<button type='button' class='nwc-mobbar-btn' data-a='checkout'>${svg('lock', 2.2)}Finalizar compra</button></div>`;
    return content + bar;
  }
  const emptyPageHTML = () => `<div class='nwc-empty'><div class='nwc-empty-ic'>${svg('bag')}</div><div class='nwc-empty-title'>Seu carrinho está vazio</div>`
    + `<div class='nwc-empty-txt'>Que tal começar com um mix de maracujá e uva? Frete grátis a partir de 2 caixas.</div>`
    + `<a class='nwc-empty-btn' href='${PRODUCT}'>Conhecer os sticks newa</a></div>`;

  function drawerInner(v){
    if (isEmpty()){
      if (state.syncing) return `<div class='nwc-dw-empty'><div class='nwc-dw-empty-title'>Carregando…</div></div>`;
      return `<div class='nwc-dw-empty'><div class='nwc-empty-ic'>${svg('bag')}</div><div class='nwc-dw-empty-title'>Seu carrinho está vazio</div><a class='nwc-empty-btn' href='${PRODUCT}'>Conhecer os sticks</a></div>`;
    }
    const item = `<div class='nwc-item sm nwc-card'><div class='nwc-thumb'><img src='${THUMB}' alt='Caixas newa'></div><div class='nwc-it-mid'>`
      + `<div class='nwc-dw-toprow'><div class='nwc-it-title' data-f='title'>${kitTitle()}</div><div class='nwc-ittot sm' data-f='ittot'>${fmt(v.tot)}</div></div>`
      + `<div class='nwc-dw-midrow2'>${removeEl('')}<div class='nwc-orig' data-f='orig' style='${hide(v.descKit > 0)}'>${fmt(v.orig)}</div></div></div>`
      + flavorsHTML(true) + `</div>`;
    const foot = `<div class='nwc-dw-foot'>` + cupBox(true) + calcHTML(v, true)
      + `<div class='nwc-totalrow sm'><span class='nwc-total-k'>Total</span><span class='nwc-total-v sm' data-f='total'>${fmt(v.total)}</span></div>`
      + `<button type='button' class='nwc-checkout sm' data-a='checkout'>${svg('lock', 2.2)}Finalizar compra · <span data-f='total'>${fmt(v.total)}</span></button>`
      + `<div class='nwc-dw-continue' role='button' data-a='close'>ou continue comprando</div></div>`;
    return missionHTML(v, true) + `<div class='nwc-dw-body'>${item}${upsellHTML(v, true)}</div>` + foot;
  }
  function drawerHTML(){
    const v = calc();
    return `<div class='nwc-ov' data-a='close'><span></span></div>`
      + `<div class='nwc-drawer' role='dialog' aria-label='Carrinho'><div class='nwc-dw-head'><div class='nwc-dw-headL'><div class='nwc-dw-title'>Carrinho</div><div class='nwc-dw-badge' data-f='dwbadge'>${v.n}</div></div>`
      + `<button type='button' class='nwc-dw-close' data-a='close' aria-label='Fechar'>${svg('x', 2.4)}</button></div>`
      + drawerInner(v) + `</div>`;
  }

  function renderPage(){
    if (!root) return;
    const v = calc();
    root.innerHTML = isEmpty() ? emptyPageHTML() : (MQ.matches ? mobileHTML(v) : desktopHTML(v));
  }
  function renderDrawer(){
    if (!drawerRoot) return;
    drawerRoot.innerHTML = state.drawer ? drawerHTML() : '';
    drawerRoot.style.display = state.drawer ? 'block' : 'none';
    document.documentElement.style.overflow = state.drawer ? 'hidden' : '';
  }
  function render(){ renderPage(); renderDrawer(); }

  function each(sel, fn){ [root, drawerRoot].forEach(sc => { if (sc) sc.querySelectorAll(sel).forEach(fn); }); }
  function T(f, t){ t = String(t); each(`[data-f='${f}']`, e => { if (e.textContent !== t) e.textContent = t; }); }
  function S(f, on){ each(`[data-f='${f}']`, e => { e.style.display = on ? '' : 'none'; }); }
  function K(f, cls, on){ each(`[data-f='${f}']`, e => { e.classList.toggle(cls, on); }); }
  function D(f, off){ each(`[data-f='${f}']`, e => { if (e.disabled !== off) e.disabled = off; }); }
  function updateBadge(n){ document.querySelectorAll('[data-nw-cart-count]').forEach(e => { e.textContent = n; }); }

  function patch(){
    const v = calc();
    T('dwbadge', v.n);
    FLAVORS.forEach(f => {
      T('q' + f.k, state[f.k]);
      K('row' + f.k, 'on', state[f.k] > 0);
      D('m' + f.k, !canMinus(f.k));
      D('p' + f.k, !canPlus());
    });
    T('ittot', fmt(v.tot));
    T('orig', fmt(v.orig)); S('orig', v.descKit > 0);
    T('offbadge', v.offPct); S('offbadge', v.descKit > 0);
    T('perstick', fmt(v.stick) + ' por stick');
    T('title', kitTitle()); T('sub', caixas() + ' · 1 produto'); T('caixas', caixas());
    T('mmsg', missionMsg());
    each(`[data-f='fill']`, e => { e.style.width = v.pct + '%'; });
    K('nfrete', 'on', v.freteOk); K('nfrete', 'off', !v.freteOk);
    K('lfrete', 'on', v.freteOk); K('lfrete', 'off', !v.freteOk);
    K('nmax', 'on', v.maxOk); K('nmax', 'off', !v.maxOk);
    K('lmax', 'on', v.maxOk); K('lmax', 'off', !v.maxOk);
    T('lorig', fmt(v.orig));
    S('lkit', v.descKit > 0); T('lkitlbl', v.offPct); T('lkitval', '−' + fmt(v.descKit));
    S('lcup', state.applied); T('lcupval', '−' + fmt(v.cup));
    T('lfreteval', freteTxt(v)); K('lfreteval', 'free', v.freteOk);
    T('total', fmt(v.total)); T('parcel', parcel(v)); T('mbl', mbl(v));
    S('up', v.n < 4); S('best', v.n >= 4);
    updateBadge(v.n);
  }

  function readCart(c){
    let mar = 0, uva = 0;
    (c.items || []).forEach(it => {
      const vid = it.variant_id || it.id;
      if (vid === MAR) mar += it.quantity;
      else if (vid === UVA) uva += it.quantity;
    });
    return { mar, uva };
  }
  function applyServer(c){
    const wasEmpty = isEmpty();
    const q = readCart(c);
    state.mar = q.mar; state.uva = q.uva;
    state.orig = c.original_total_price || 0; state.tot = c.total_price || 0;
    if (N() > 0 && state.orig > 0) unit = Math.round(state.orig / N());
    if (wasEmpty !== isEmpty()) render(); else patch();
  }
  function getCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json()); }
  function resync(){
    const v0 = localVer;
    return getCart().then(c => { if (!inFlight && v0 === localVer && sentVer === localVer) applyServer(c); }).catch(() => {});
  }

  function schedule(){ clearTimeout(timer); timer = setTimeout(flush, 280); }
  function flush(){
    clearTimeout(timer);
    if (inFlight || sentVer === localVer) return;
    inFlight = true;
    const ver = localVer;
    const updates = {}; updates[MAR] = state.mar; updates[UVA] = state.uva;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates }) })
      .then(r => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(c => {
        inFlight = false; sentVer = Math.max(sentVer, ver);
        if (ver === localVer) applyServer(c); else flush();
      })
      .catch(() => {
        inFlight = false; sentVer = Math.max(sentVer, ver);
        if (ver === localVer) resync(); else flush();
      });
  }
  function setMix(mar, uva){
    const n = mar + uva;
    if (state.syncing || mar < 0 || uva < 0 || n < 1 || n > MAXN) return;
    if (mar === state.mar && uva === state.uva) return;
    state.mar = mar; state.uva = uva;
    const u = unit || 5900;
    state.orig = n * u;
    state.tot = Math.round(n * u * (100 - tierPct(n)) / 100);
    localVer++;
    patch();
    schedule();
  }
  function step(k, d){
    if (d > 0 && !canPlus()) return;
    if (d < 0 && !canMinus(k)) return;
    if (k === 'mar') setMix(state.mar + d, state.uva); else setMix(state.mar, state.uva + d);
  }
  function upgrade(){
    const n = N();
    if (n >= 4 || n < 1) return;
    let m;
    if (state.mar === 0) m = 0;
    else if (state.uva === 0) m = 4;
    else m = Math.min(3, Math.max(1, Math.round(4 * state.mar / n)));
    setMix(m, 4 - m);
  }
  function clearCart(){
    if (state.syncing) return;
    clearTimeout(timer);
    localVer++; sentVer = localVer;
    state.mar = 0; state.uva = 0; state.orig = 0; state.tot = 0;
    render();
    const go = () => fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(c => { if (!inFlight && sentVer === localVer) applyServer(c); })
      .catch(resync);
    if (inFlight){ const iv = setInterval(() => { if (!inFlight){ clearInterval(iv); go(); } }, 50); } else go();
  }
  function goCheckout(){
    let done = false;
    const go = () => { if (done) return; done = true; window.location.href = CHECKOUT; };
    if (!inFlight && sentVer === localVer) return go();
    flush();
    const iv = setInterval(() => { if (!inFlight && sentVer === localVer){ clearInterval(iv); go(); } }, 50);
    setTimeout(() => { clearInterval(iv); go(); }, 5000);
  }
  function renderCoupon(){ each(`[data-f='cupbox']`, e => { e.innerHTML = couponHTML(e.getAttribute('data-sm') === '1'); }); }
  function applyCoupon(){
    const code = (state.coupon || '').trim().toUpperCase();
    if (code === 'NEWA10'){ state.applied = true; state.coupon = ''; state.couponErr = false; }
    else state.couponErr = true;
    renderCoupon(); patch();
  }
  function openDrawer(){
    state.drawer = true; state.syncing = true;
    renderDrawer();
    const v0 = localVer;
    getCart().then(c => {
      state.syncing = false;
      if (!inFlight && v0 === localVer && sentVer === localVer){
        const wasEmpty = isEmpty();
        applyServer(c);
        if (wasEmpty && isEmpty()) renderDrawer();
      } else patch();
    }).catch(() => { state.syncing = false; renderDrawer(); });
  }
  function closeDrawer(){ state.drawer = false; renderDrawer(); }

  function onClick(e){
    const el = e.target.closest('[data-a]');
    if (!el) return;
    const a = el.getAttribute('data-a');
    if (a === 'plus') step(el.getAttribute('data-k'), 1);
    else if (a === 'minus') step(el.getAttribute('data-k'), -1);
    else if (a === 'upgrade') upgrade();
    else if (a === 'remove') clearCart();
    else if (a === 'apply') applyCoupon();
    else if (a === 'rmcoupon'){ state.applied = false; renderCoupon(); patch(); }
    else if (a === 'checkout') goCheckout();
    else if (a === 'close') closeDrawer();
  }
  [root, drawerRoot].forEach(sc => {
    if (!sc) return;
    sc.addEventListener('click', onClick);
    sc.addEventListener('input', e => { if (e.target.matches && e.target.matches(`[data-a='coupon']`)){ state.coupon = e.target.value; state.couponErr = false; } });
    sc.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target.matches && e.target.matches(`[data-a='coupon']`)){ e.preventDefault(); applyCoupon(); } });
  });
  document.querySelectorAll(`a.nwh-ib[href$='/cart'], a.nwh-ib[href$='cart']`).forEach(a => a.addEventListener('click', e => { e.preventDefault(); openDrawer(); }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && state.drawer) closeDrawer(); });
  if (MQ.addEventListener) MQ.addEventListener('change', renderPage); else if (MQ.addListener) MQ.addListener(renderPage);
  window.addEventListener('pagehide', () => {
    if (sentVer !== localVer && navigator.sendBeacon){
      const fd = new URLSearchParams();
      fd.append('updates[' + MAR + ']', state.mar);
      fd.append('updates[' + UVA + ']', state.uva);
      navigator.sendBeacon('/cart/update.js', fd);
    }
  });
  window.NEWA_CART = { open: openDrawer };

  render();
  if (root){
    state.syncing = true; patch();
    const v0 = localVer;
    getCart().then(c => { state.syncing = false; if (v0 === localVer) applyServer(c); else patch(); })
      .catch(() => { state.syncing = false; patch(); });
  }
})();
